import axios from "axios";
import {
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { useEffect, useState } from "react";
import initializeFirebase from "../Firebase/initializeFirebase";

initializeFirebase();

const useFirebase = () => {
  const [user, setUser] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [isAdmin, setIsAdmin] = useState(null);

  const auth = getAuth();

  //get current user
  useEffect(() => {
    setIsLoading(true);
    const unSubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
      } else {
        // User is signed out
      }
      setIsLoading(false);
    });
    return () => unSubscribe();
  }, [auth]);

  //check admin
  useEffect(() => {
    axios
      .get(`https://infinite-cliffs-70499.herokuapp.com/admin/${user?.email}`)
      .then((res) => {
        setIsAdmin(res.data?.isAdmin);
      });
  }, [user?.email]);

  const logInUsingEmail = (email, password, navigate, destination) => {
    setIsLoading(true);
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user;
        setUser(user);
        navigate(destination);
        setError("");
      })
      .catch((error) => {
        setError(error.message);
      })
      .finally(() => setIsLoading(false));
  };

  //log out
  const logOutUser = () => {
    setIsLoading(true);
    signOut(auth)
      .then(() => {
        setUser({});
      })
      .catch((error) => {
        // An error happened.
      })
      .finally(() => setIsLoading(false));
  };
  return {
    user,
    logInUsingEmail,
    error,
    logOutUser,
    isLoading,
    setError,
    isAdmin,
  };
};

export default useFirebase;
